import keyNames from "../../keyName";
export const initialState = {
  [keyNames.themeMode]: "light",
  [keyNames.apiErrors]: null,
  [keyNames.extra]: null,
  [keyNames.isLoading]: "noLoading",
  [keyNames.toastData]: null,
  [keyNames.userData]: null,
  [keyNames.forceLogOut]: false,
  [keyNames.registeredUserData]: null,
  [keyNames.verifyOtpData]: null,
  [keyNames.otpData]: null,
  [keyNames.caseStudyData]: null,
  [keyNames.dialogData]: null,
  [keyNames.galleryData]: null,
};
